import { manageSeatingRedirectClickAction } from "../../../Actions/UIActions/ManageSeating/ManageSeatingRedirectClickAction";
import { ExecutionStatus } from "../../../core/enum/ExecutionStatus";
import { _eventBus } from "../../../core/events/EventBus";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { StepFlow } from "../../../core/flows/StepFlow";
import { bookingTree } from "../../../Orchestrator/ConstantTree";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IDefaultActionResult } from "../../../Orchestrator/Types/Interface/ActionParams/DefaultActionResult";
import { ManageSeatingContext } from "../Context/ManageSeatingContext";
import { resetManageSeatingState } from "../../../Actions/UIActions/ManageSeating/ResetManageSeatingStateAction";

class ManageSeatingInitStep extends StepFlow {
    get stepName() { return "ManageSeatingInit_Step"; }

    async onEventSetup(): Promise<void> {
        /**
        * This event used to close flow
        */
        _eventBus.on<void, void>({
            eventName: bookingTree.ManageSeating.Flow.Close,
            handler: async (payload) => {
                // Ensure manage seating state is fully reset on close
                resetManageSeatingState();
                const context = this.getCtx<ManageSeatingContext>("manageSeatingContext")!
                if (context) {
                    context.routeTo = []
                    this.next()
                }
            }
        })

        this.registerEventSubscription(
            _eventBus.on({
                eventName: bookingTree.ManageSeating.Redirect.Click,
                handler: async (data: any) => {
                    manageSeatingRedirectClickAction.setParams(data.data!);
                    await manageSeatingRedirectClickAction.execute();
                    if (manageSeatingRedirectClickAction.status.executionStatus === ExecutionStatus.SUCCESS) {
                        const data: IDefaultActionResult = manageSeatingRedirectClickAction.result!;
                        if (data.status === "success") {
                            try {
                                sessionStorage.setItem("checkoutFromWithLogin", "true");
                            } catch (error) {
                                console.error("Error setting sessionStorage checkoutFromWithLogin:", error);
                            }

                            const manageSeatingContext = this.getCtx<ManageSeatingContext>("manageSeatingContext");
                            if (manageSeatingContext) {
                                manageSeatingContext.routeTo = ["CheckoutFlow"];
                                this.next();
                            }


                            // Delay the ROUTE_CHANGE event emission slightly
                            setTimeout(() => {
                                // Reset addon state before /checkout mount so CheckoutTripSummary's
                                // useEffect doesn't fire GetBookingOffersAddOns while the first
                                // AddOnsInit_Step's subscriber has been torn down by closeFlows
                                // and the new CheckoutFlow's subscriber is not yet registered.
                                // Mirrors the fix in UpgradeToPremiumAction.handleDirectCheckout.
                                updateRecoilState("addonFlowStartedAtom", false);
                                updateRecoilState("mealPreferencesResponseAtom", {});

                                _eventBus.emit({
                                    eventName: "ROUTE_CHANGE",
                                    data: "/checkout"
                                });
                            }, 0);
                        }
                    }
                }
            })
        )
    }

    async onExecute(): Promise<void> {
        console.log("ManageSeating Init Step Execute.............................")
    }
}

export const ManageSeatingInitStepDeclaration = new StepDefinition({
    stepName: "ManageSeatingInit_Step",
    stepClass: ManageSeatingInitStep
});